var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLoginBranca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1089",
    "data-name": "Grupo 1089",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.806,
    height: 115.2,
    viewBox: "0 0 270.806 115.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_161",
    "data-name": "Ret\\xE2ngulo 161",
    width: 270.806,
    height: 115.2,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M5.588,63.187,36.117,80.813a11.174,11.174,0,0,1,4.09,15.264L29.166,115.2h60.06a11.175,11.175,0,0,0,9.678-5.588l24.443-42.335a11.176,11.176,0,0,0-4.09-15.264L88.73,34.387a11.176,11.176,0,0,1-4.092-15.266L95.677,0H35.617a11.172,11.172,0,0,0-9.676,5.588L1.5,47.923a11.176,11.176,0,0,0,4.09,15.264",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M74.705,41.3a11.787,11.787,0,0,0,7.831,3.131c2.4,0,3.849-.953,3.849-2.514v-.077c0-1.485-.914-2.247-5.373-3.391-5.371-1.37-8.837-2.857-8.837-8.152v-.075c0-4.84,3.885-8.039,9.333-8.039a14.807,14.807,0,0,1,9.717,3.241l-2.7,4.678a13.178,13.178,0,0,0-7.092-2.739c-2.249,0-3.43,1.03-3.43,2.325v.077c0,1.752,1.144,2.323,5.753,3.505,5.411,1.408,8.459,3.353,8.459,8v.075c0,5.3-4.111,8.268-9.792,8.268a19.694,19.694,0,0,1-10.459-3.564Z",
    transform: "translate(74.267 22.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M105.337,36.037v-.075A8.1,8.1,0,0,0,97.26,27.58a7.974,7.974,0,0,0-8,8.3v.077a8.1,8.1,0,0,0,8.077,8.38,7.976,7.976,0,0,0,8-8.3m-22.212,0v-.075A13.793,13.793,0,0,1,97.337,22.169c8.228,0,14.135,6.135,14.135,13.716v.077A13.791,13.791,0,0,1,97.26,49.753c-8.23,0-14.135-6.135-14.135-13.716",
    transform: "translate(85.785 22.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M105.773,27.776H97.657V22.365h22.1v5.411h-8.116V49.035h-5.866Z",
    transform: "translate(100.782 23.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M110.2,22.365h20.117v5.22H116.025v5.409H128.6v5.22H116.025v5.6H130.5v5.22H110.2Z",
    transform: "translate(113.722 23.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M133.661,35.319c2.859,0,4.5-1.524,4.5-3.771V31.47c0-2.514-1.754-3.81-4.611-3.81h-5.83v7.659ZM121.853,22.365h12.192c3.389,0,6.017.953,7.77,2.7a8.378,8.378,0,0,1,2.286,6.1v.077a8.281,8.281,0,0,1-5.716,8.266l6.517,9.526h-6.858L132.328,40.5h-4.611v8.534h-5.864Z",
    transform: "translate(125.752 23.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M71.993,43h4.631v1.2H73.336v1.246h2.894v1.2H73.336V47.94h3.332v1.2H71.993Z",
    transform: "translate(74.296 44.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M78.339,43h1.246l2.877,3.782V43h1.333v6.141H82.647l-2.975-3.9v3.9H78.339Z",
    transform: "translate(80.845 44.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M85.069,46.143v-.018a3.15,3.15,0,0,1,3.219-3.174,3.375,3.375,0,0,1,2.412.841l-.849,1.026a2.264,2.264,0,0,0-1.605-.622,1.844,1.844,0,0,0-1.764,1.912v.016a1.84,1.84,0,0,0,1.859,1.949,2.152,2.152,0,0,0,1.272-.37v-.876H88.253V45.662h2.668v2.666A4,4,0,0,1,88.3,49.3a3.073,3.073,0,0,1-3.229-3.158",
    transform: "translate(87.791 44.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M92.04,43h4.631v1.2H93.384v1.246h2.894v1.2H93.384V47.94h3.332v1.2H92.04Z",
    transform: "translate(94.985 44.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M98.386,43h1.246l2.877,3.782V43h1.333v6.141h-1.148l-2.975-3.9v3.9H98.386Z",
    transform: "translate(101.534 44.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M105.25,43H106.6v2.43h2.491V43h1.351v6.141h-1.351V46.678H106.6v2.465H105.25Z",
    transform: "translate(108.618 44.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M115.778,46.6l-.815-1.991-.817,1.991Zm-1.42-3.615H115.6l2.631,6.183h-1.412l-.561-1.376h-2.6l-.561,1.376h-1.378Z",
    transform: "translate(115.301 44.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M121.567,45.985c.658,0,1.036-.352,1.036-.87V45.1c0-.579-.4-.878-1.063-.878H120.2v1.764ZM118.848,43h2.806a2.449,2.449,0,0,1,1.79.622,1.934,1.934,0,0,1,.526,1.4v.018a1.908,1.908,0,0,1-1.315,1.9l1.5,2.193h-1.579l-1.317-1.965H120.2v1.965h-1.351Z",
    transform: "translate(122.651 44.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_160",
    "data-name": "Ret\\xE2ngulo 160",
    width: 1.349,
    height: 6.141,
    transform: "translate(254.922 87.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M134.12,46.6,133.3,44.6l-.817,1.991Zm-1.42-3.615h1.246l2.631,6.183h-1.412l-.561-1.376h-2.6l-.561,1.376h-1.378Z",
    transform: "translate(134.23 44.356)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoginBranca);
export default __webpack_public_path__ + "static/media/logo_login_branca.2027332a96255f90d014cd480d85f7ab.svg";
export { ForwardRef as ReactComponent };